<template>
    <b-modal
        v-model="modalVisivel"
        :title="titulo"
        size="xl"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        @hide="$emit('fechouModal', true)"
    >
        <div class="d-flex justify-content-center">
            <iframe id="frameAssinatura" :src="src" frameborder="0"></iframe>
        </div>
    </b-modal>
</template>

<script>
    export default {
        props: {
            value: {
                type   : Boolean,
                default: false
            },
            src: {
                type   : String,
                default: ""
            },
            titulo: {
                type   : String,
                default: ""
            }
        },
        computed: {
            modalVisivel: {
                get() { return this.value; },
                set(val) { this.$emit('input', val); }
            }
        }
    }
</script>

<style>
    #frameAssinatura{
        width : 100%;
        height: calc(100vh - 150px);
    }
</style>